import React from "react";
import { Modal, Accordion, Card, Button } from "react-bootstrap";

class DownloadModal extends React.Component {
  state = {
    show: false,
    toggleInfo: false,
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  handleShow = (e) => {
    if (this.props.onShow) {
      this.props.onShow(e);
    }
    this.setState({ show: true });
    // if (window.CHASE) {
    //   window.CHASE.analytics.trackModalLoad(
    //     "cf-example-modal",
    //     `cf-${this.props.modalId}s-modal`
    //   );
    // }
  };
  actionsHelper = () => {
    if (this.props.action) {
      return (
        <Modal.Footer>
          <button
            onClick={this.props.action}
            className="btn btn-primary"
            // data-pt-name={`${this.props.dataptname}_ok`}
          >
            OK
          </button>
          <button
            onClick={this.handleClose}
            className="btn btn-secondary"
            // data-pt-name={`${this.props.dataptname}_close`}
          >
            Close
          </button>
        </Modal.Footer>
      );
    } else {
      return (
        <Modal.Footer>
          <button
            onClick={this.handleClose}
            className="btn btn-primary"
            // data-pt-name={`${this.props.dataptname}_close`}
          >
            Close
          </button>
        </Modal.Footer>
      );
    }
  };

  render() {
    return (
      <>
        <a
          href=""
          onClick={this.handleShow}
          className={this.props.buttonClass}
          download="my-2020.png"
          // So data-pt-name={this.props.dataptname}
        >
          {this.props.label}
        </a>

        <Modal size="lg" show={this.state.show} className={`${this.props.modalId}-modal avatar-modal`} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title as="h3">Your 2020 Avatar is downloading.</Modal.Title>
            <button
              type="button"
              className="close"
              // data-pt-name={`${this.props.dataptname}_x-button`}
              onClick={this.handleClose}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Accordion>
                <>
                  <p className="m-0">
                    (Check your downloads folder!)
                    <Accordion.Toggle as={Button} variant="link" eventKey="0">
                      Need more information?
                    </Accordion.Toggle>
                  </p>
                  <Accordion.Collapse eventKey="0">
                    <div>
                      <h4>How to find a file you've downloaded to your iPhone </h4>
                      <ol>
                        <li>Start the Files app, which looks like a blue folder on a white background. </li>
                        <li>In the Browse section, tap a location where you want to browse. ... </li>
                        <li>Tap to open subfolders as needed to find the file you want. </li>
                        <li>Tap the file you want to open. </li>
                      </ol>
                      <h4>How to find downloads on your Android device</h4>
                      <ol>
                        <li>Open the Android app drawer by swiping up from the bottom of the screen.</li>
                        <li>Look for the My Files (or File Manager) icon and tap it. ... </li>
                        <li>Inside the My Files app, tap "Downloads."</li>
                      </ol>
                    </div>
                  </Accordion.Collapse>
                </>
              </Accordion>
              <h4 className="pt-5">
                <strong>What's next?</strong>
              </h4>
              <p>Tweet it, Gram it, whatever your thing is - just share it! Let the world see your methods for getting through the madness in 2020.</p>
            </div>
          </Modal.Body>
          {this.actionsHelper()}
        </Modal>
      </>
    );
  }
}

export default DownloadModal;
